import { FC } from 'react';
import { Circle, Stack, StackProps, Text } from '@chakra-ui/react';

export type PillProps = {
  label: string;
  hideCircle?: boolean;
  colorPalette?: string;
} & StackProps;

// hack: Map gray palette to old Chakra v2 values
const getColor = (colorPalette: string, shade: string) => {
  if (colorPalette === 'gray') {
    const grayOverrides: Record<string, string> = {
      '100': '#EEF2F7',
      '500': '#768092',
    };
    return grayOverrides[shade] || `${colorPalette}.${shade}`;
  }
  return `${colorPalette}.${shade}`;
};

export const Pill: FC<PillProps> = ({
  label,
  hideCircle = false,
  colorPalette = 'gray',
  ...props
}) => (
  <Stack
    alignItems="center"
    bg={getColor(colorPalette, '100')}
    direction="row"
    px={3}
    py={1}
    rounded="full"
    w="max-content"
    {...props}
  >
    {!hideCircle && <Circle bg={getColor(colorPalette, '500')} size="9px" />}
    <Text>{label}</Text>
  </Stack>
);
